
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RouteNames from "@/entities/RouteNames";

  @Component
  export default class ApplicantChip extends Vue {
    @Prop({ type: String, default: undefined }) readonly applicantId!: string;
    @Prop({ type: String, required: true }) readonly applicantName!: string;
    @Prop({ type: String, default: undefined }) readonly contractorId?: string;

    get linkParams() {
      if (this.contractorId) {
        return {
          name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
          params: { id: this.contractorId },
        };
      }
      return {
        name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
        params: { id: this.applicantId },
      };
    }
  }
